import * as Sentry from '@sentry/react';
import { isServer, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { HTTPError } from 'ky';

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 300, // throttling 방지
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (error instanceof HTTPError) {
            // 401, 403, 404는 재시도하지 않음
            if ([401, 403, 404].includes(error.response.status)) return false;
            return failureCount < 3;
          }
          return failureCount < 3;
        },
      },
      mutations: {
        onError: (error) => {
          // 401은 인증 만료이므로 Sentry에 보고하지 않음
          if (error instanceof HTTPError && error.response.status === 401) {
            return;
          }
          Sentry.captureException(error);
        },
      },
    },
  });
}

let browserQueryClient: QueryClient | undefined;

function getQueryClient() {
  if (isServer) {
    return makeQueryClient();
  } else {
    browserQueryClient ??= makeQueryClient();
    return browserQueryClient;
  }
}

export function QueryProvider({ children }: Readonly<{ children: React.ReactNode }>) {
  const queryClient = getQueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      {children}
    </QueryClientProvider>
  );
}
